<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div
            v-if="loadingActionCreate"
            class="card-body d-flex align-items-center justify-content-center"
            style="height: calc(100vh - 144px)"
          >
            <div class="text-center text-primary my-2 loader">
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="!loadingActionCreate" class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Experian Search</h4>
            <!-- Card Title -->
            <p class="card-title-desc">
              Try to find the Organization at Experian
            </p>
            <!-- Card Title Description -->

            <form
              method="post"
              class="needs-validation"
              @submit.prevent="onSubmit"
              novalidate
            >
              <input
                type="hidden"
                name="csrfmiddlewaretoken"
                value="VWFkoyCqErMhY2CpzfJvrzzWbDYIwkAEufU0DwOriEbiCx3vZyx4Y55NaR6s0jNQ"
              />

              <div class="row">
                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="state" class="form-label">State</label>
                    <v-select
                      v-model.trim="$v.state.$model"
                      :options="options"
                    ></v-select>

                    <div
                      v-if="submitted && !$v.state.required"
                      class="invalid-tooltip"
                    >
                      This field is required
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="city" class="form-label">City</label>

                    <input
                      type="text"
                      class="form-control"
                      id="city"
                      name="city"
                      placeholder="City"
                      required=""
                      v-model.trim="$v.city.$model"
                    />

                    <div
                      v-if="submitted && !$v.city.required"
                      class="invalid-tooltip"
                    >
                      Please provide a valid city.
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="organization_name" class="form-label"
                      >Organization Name</label
                    >

                    <input
                      type="text"
                      class="form-control"
                      id="organization_name"
                      name="organization_name"
                      placeholder="Organization Name"
                      required=""
                      v-model.trim="$v.name.$model"
                    />

                    <div
                      v-if="submitted && !$v.name.required"
                      class="invalid-tooltip"
                    >
                      Please provide a valid organization name.
                    </div>
                  </div>
                </div>
              </div>

              <p
                v-if="
                  submitted && showResult && results && results.length === 0
                "
              >
                No organizations matching your criteria. Please check your
                search information and try again or
                <router-link to="/mpg/organizations/create"
                  >manually create an organization</router-link
                >
              </p>

              <div>
                <button
                  class="btn btn-primary"
                  type="submit"
                  name="search"
                  value="search"
                  :disabled="loadingAction"
                >
                  Search
                </button>
              </div>
            </form>
          </div>
          <!-- End Card Body -->
        </div>
        <!-- End Card -->
      </div>

      <div class="col-12 mt-4" v-if="showResult">
        <div class="card">
          <div class="card-header pb-0 px-3">
            <h6 class="mb-0">Search Results</h6>
          </div>
          <div class="card-body pt-4 p-3">
            <div class="text-center text-primary my-2" v-if="loadingAction">
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
            <div class="row" v-if="!loadingAction">
              <div
                class="col-12 col-md-12"
                v-if="results && results.length === 0"
              >
                <div
                  class="
                    list-group-item
                    border-0
                    p-4
                    mb-2
                    bg-gray-100
                    border-radius-lg
                    text-center
                  "
                >
                  There is no data.
                </div>
              </div>
              <template v-if="results && results.length > 0">
                <div
                  class="col-12 col-md-6"
                  v-for="(item, key) in results"
                  :key="key"
                >
                  <div
                    class="
                      list-group-item
                      border-0
                      d-flex
                      p-4
                      mb-2
                      bg-gray-100
                      border-radius-lg
                    "
                  >
                    <div class="d-flex flex-column">
                      <h6 class="mb-3 text-sm">{{ item.business_name }}</h6>
                      <span class="mb-2 text-xs"
                        >Address:
                        <span class="text-dark font-weight-bold ms-sm-2">{{
                          item.address
                        }}</span></span
                      >
                      <span class="mb-2 text-xs"
                        >Phone:
                        <span class="text-dark ms-sm-2 font-weight-bold">{{
                          item.phone
                        }}</span></span
                      >
                      <span class="text-xs"
                        >Experian ID:
                        <span class="text-dark ms-sm-2 font-weight-bold">{{
                          item.bin
                        }}</span></span
                      >
                    </div>
                    <div class="ms-auto text-end">
                      <button
                        :disabled="item.alive || loadingActionCreate"
                        @click="onCreateExperian(item.bin, item.created)"
                        class="btn btn-success waves-effect waves-light"
                      >
                        Add
                      </button>
                      <div class="text-danger mt-4" v-if="item.alive">
                        This organization already exist
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <template v-if="$route.query.opportunity">
            <div class="card-header pb-0 px-3">
              <div
                class="d-flex"
                style="align-items: center; justify-content: space-between"
              >
                <h6 class="mb-0">Organizations Queue</h6>
                <button
                  :disabled="isAddingOrgToOpp"
                  @click="onAddSelectOrgToOpp()"
                  class="btn btn-success waves-effect waves-light"
                >
                  Add to Opportunity
                </button>
              </div>
            </div>
            <div class="card-body pt-4 p-3">
              <div class="text-center text-primary my-2" v-if="loadingAction">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>Loading...</strong>
              </div>
              <div class="row" v-if="!loadingAction">
                <div
                  class="col-12 col-md-12"
                  v-if="results && results.length === 0"
                >
                  <div
                    class="
                      list-group-item
                      border-0
                      p-4
                      mb-2
                      bg-gray-100
                      border-radius-lg
                      text-center
                    "
                  >
                    There is no data.
                  </div>
                </div>
                <template v-if="results && results.length > 0">
                  <div
                    class="col-12 col-md-6"
                    v-for="(item, key) in results"
                    :key="key"
                  >
                    <div
                      class="
                        list-group-item
                        border-0
                        d-flex
                        p-4
                        mb-2
                        bg-gray-100
                        border-radius-lg
                      "
                      :class="{
                        activeCard: selectedOrgToAdd.find(
                          (e) => e.bin === item.bin
                        ),
                      }"
                    >
                      <div class="d-flex flex-column">
                        <h6 class="mb-3 text-sm">{{ item.business_name }}</h6>
                        <span class="mb-2 text-xs"
                          >Address:
                          <span class="text-dark font-weight-bold ms-sm-2">{{
                            item.address
                          }}</span></span
                        >
                        <span class="mb-2 text-xs"
                          >Phone:
                          <span class="text-dark ms-sm-2 font-weight-bold">{{
                            item.phone
                          }}</span></span
                        >
                        <span class="text-xs"
                          >Experian ID:
                          <span class="text-dark ms-sm-2 font-weight-bold">{{
                            item.bin
                          }}</span></span
                        >
                      </div>
                      <div class="ms-auto text-end">
                        <button
                          @click="onAddToOpp(item)"
                          class="btn btn-success waves-effect waves-light"
                        >
                          {{
                            !selectedOrgToAdd.find((e) => e.bin === item.bin)
                              ? "Select"
                              : "UnSelect"
                          }}
                        </button>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { opportunityService } from '../services/opportunities.service'
import { organizationsService } from '../services/organizations.service'
import { required } from 'vuelidate/lib/validators'
import { utilService } from '../services/util.service'
import moment from 'moment'
import { router } from '../router'

export default {
  name: 'SearchOrganizations',
  components: {},
  data () {
    return {
      state: '',
      name: '',
      city: '',
      options: [],
      submitted: false,
      loadingAction: false,
      showResult: false,
      results: null,
      loadingActionCreate: false,
      selectedOrgToAdd: [],
      isAddingOrgToOpp: false
    }
  },
  validations: {
    state: { required },
    name: { required },
    city: { required }
  },
  computed: {},
  created () {
    utilService.getState().then((rs) => {
      this.options = rs.results.map((e) => {
        e.label = e.acronym
        e.code = e.state_id
        return e
      })
    })
  },
  methods: {
    moment,
    onAddSelectOrgToOpp () {
      if (!this.selectedOrgToAdd || this.selectedOrgToAdd.length === 0) {
        return
      }
      this.isAddingOrgToOpp = true
      opportunityService.getDataById(this.$route.query.opportunity, true).then((oppData) => {
        let promises = []
        this.selectedOrgToAdd.forEach((org) => {
          const parts = org.address.split(',')

          const payload = {
            name: org.business_name,
            bin_number: org.bin,
            address_street: org.address,
            state: this.state && this.state.code ? this.state.code : '',
            city: this.city ? this.city : '',
            zip_code: parts[parts.length - 1].trim()
          }
          promises.push(
            organizationsService.add(payload).then(
              (rs) => {
                return rs
              },
              (err) => {
                console.log(err)
                throw new Error('Cannot add')
              }
            )
          )
        })

        Promise.all(promises)
          .then((data) => {
            this.isAddingOrgToOpp = false
            opportunityService
              .updateWithPath(
                {
                  organizations: [
                    ...oppData.organizations,
                    ...data.map((e) => e.organization_id)
                  ]
                },
                this.$route.query.opportunity
              )
              .then((rs) => {
                this.$bvToast.toast('Add successfully.', {
                  title: `Update`,
                  variant: 'primary',
                  solid: true
                })
                this.isAddingOrgToOpp = false
                this.$router.go(-1)
              })
          })
          .catch(() => {
            this.$bvToast.toast('Cannot Add Organization.', {
              title: `Update`,
              variant: 'danger',
              solid: true
            })
            this.isAddingOrgToOpp = false
          })
      })
    },
    onAddToOpp (item) {
      if (this.selectedOrgToAdd.find((e) => e.bin === item.bin)) {
        this.selectedOrgToAdd = this.selectedOrgToAdd.filter(
          (e) => e.bin !== item.bin
        )
      } else {
        this.selectedOrgToAdd.push(item)
      }
    },
    onSubmit () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return false
      }
      this.showResult = true
      this.loadingAction = true
      organizationsService
        .searchExperian({
          organization_name: this.name,
          state: this.state.code,
          city: this.city
        })
        .then((rs) => {
          this.results = rs.results
          this.loadingAction = false
        })
        .catch(() => {
          this.results = []
          this.loadingAction = false
        })
    },
    onCreateExperian (bin, created) {
      this.loadingActionCreate = true
      const payload = { bin: bin, created: created }
      organizationsService
        .createDataByBin(payload)
        .then((result) => {
          router.push(
            '/mpg/organizations/' + result.details.organization_id + '/details'
          )
          this.loadingActionCreate = false
        })
        .catch((e) => {
          this.$bvToast.toast(
            'Cannot create this organization this time. Please try again later.',
            {
              title: `Validation`,
              variant: 'danger'
            }
          )
          this.loadingActionCreate = false
        })
    }
  }
}
</script>

<style lang="css" scoped>
.activeCard {
  box-shadow: 0px 0px 10px #0060ad87;
}
</style>



// WEBPACK FOOTER //
// src/pages/SearchOrganizations.vue